<template>
  <header class="py-5 bg-white">
    <div class="container">
      <div class="row">
        <div class="col-3">
          <router-link :to="{ name: 'index' }"
            ><img src="@/assets/img/logo.png" alt="logo" height="50"
          /></router-link>
        </div>
        <div class="col-9 text-right">
          <router-link :to="{ name: 'pricing' }" class="text-body mr-3"
            >Pricing</router-link
          >
          <router-link :to="{ name: 'support' }" class="text-body mr-3"
            >Contact</router-link
          >
          <router-link :to="{ name: 'home' }" class="btn btn-primary text-white"
            >Sign In</router-link
          >
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {};
</script>

<style>
</style>